import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const ObjectSidebarContent: LoadableType<{}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ObjectSidebarContent" */ '../src/ObjectSidebarContent.tsx'
			)
		).ObjectSidebarContent,
});
